export const AbsenceEn = {
    "reasonAbsence": {
        "title": "Absence reason",
        "breadCrumb": "Manager absence reason",
        "pageHeader": {
            "reasonAbsence": "Manager absence reason",
            "add": "Create a new absence reason",
            "update": "update the absence reason"
        }
    }
}
